export enum ActiveType {
	Inactive = 0,
	Active = 1,
	All = 2,
}
